import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import FirmwareEditor from './EditorPages/FirmwareEditor';
import FirmwareResults from './ResultsPages/FirmwareResults';

function Firmwares({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <FirmwareEditor id={queryParams['id']} /> :
            <FirmwareResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Firmwares);